import React from 'react';
import { Link } from 'react-router-dom';

/**
 * BrandLogo — the Datames logo (orange bust illustration).
 *
 * Phase-9 redesign: replaces the previous gradient square + Activity icon.
 * Three size variants so we can drop the same asset in different layouts:
 *   - sm  (h-7 w-7)   — sidebar / drawer brand mark
 *   - md  (h-10 w-10) — sign-in / sign-up page header
 *   - lg  (h-16 w-16) — marketing / empty states
 *
 * The optional `link` prop wraps the image in a router Link pointing at
 * the dashboard. Pass `link={null}` to render a bare image (e.g. on
 * the auth screen where the logo is decorative).
 */
export function BrandLogo({ size = 'sm', link = '/', brandLabel = 'Datames', brandSubtitle }) {
  const dim = size === 'lg' ? 'h-16 w-16' : size === 'md' ? 'h-10 w-10' : 'h-7 w-7';
  const ringShadow = 'shadow-[0_0_0_1px_hsl(var(--border))]';
  const img = (
    <img
      src="/logo.png"
      alt={`${brandLabel} logo`}
      className={`${dim} ${ringShadow} rounded-md object-cover`}
      draggable="false"
    />
  );
  if (!link) return img;
  return (
    <Link to={link} className="flex items-center gap-2.5 group" aria-label={brandLabel}>
      {img}
      <div className="flex flex-col leading-tight">
        <span className="text-sm font-semibold text-fg">{brandLabel}</span>
        {brandSubtitle && (
          <span className="text-2xs text-fg-muted uppercase tracking-wider">{brandSubtitle}</span>
        )}
      </div>
    </Link>
  );
}
